import HeartBeats from './HeartBeats';

export default HeartBeats;
